"use client";

import FancyLoader from "@/components/common/FancyLoader";
import clsx from "clsx";

type ApplicationProgressProps = {
  message: string;
  description?: string;
};

export default function ApplicationProgress({
  message,
  description,
}: Readonly<ApplicationProgressProps>) {
  return (
    <div
      className={clsx(
        "flex flex-col items-center justify-center gap-4 py-12 text-center",
      )}
      aria-live="polite"
    >
      <FancyLoader />
      <p className="font-monument text-lg font-medium text-foreground">{message}</p>
      {description ? (
        <p className="max-w-md text-sm text-gail-gray">{description}</p>
      ) : null}
    </div>
  );
}
